<template>
	<div class="home">
		<div style="padding:6px 12px;">
			<h2>Добро пожаловать в админ панель IWEP.KZ</h2>
			<div>Если возникнут вопросы, писать сюда: <a href="mailto:arman@sergazin.kz">arman@sergazin.kz</a></div>
		</div>
	</div>
</template>

<script>
export default {

  name: 'home',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>